module.exports = __webpack_public_path__ + "static/landing-ad2d65ccd815cb52ad48f6d8eed74638.png";